import React from 'react';
import useContentArea from '../service/useContentArea';

interface Props {
    areaName: string;
}

const ContentAreaDisplay = ({areaName}: Props) => {
    const content = useContentArea(areaName);
    return content ?
        <div
            className={`content-area content-area-${areaName}`}
            dangerouslySetInnerHTML={{ __html: content }}
        /> :
        <></>;
};

export default ContentAreaDisplay;
